import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["title"];
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import files from "../../../../assets/icon/files.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-file',
  props: {
    content: {
      "default": function _default() {
        return {};
      }
    },
    messageItem: {
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    // todo: 区分 web 和 uniapp
    var download = function download() {
      var _window;
      if (props.messageItem.hasRiskContent) {
        return;
      }
      var option = {
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      };
      // 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if ((_window = window) !== null && _window !== void 0 && _window.fetch) {
        fetch(props.content.url, option).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = props.content.name;
          a.click();
        });
      } else {
        var a = document.createElement("a");
        a.href = props.content.url;
        a.target = "_blank";
        a.download = props.content.name;
        a.click();
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "fileMessageContainer",
        title: _unref(TUITranslateService).t('TUIChat.单击下载'),
        onClick: download
      }, [_createVNode(Icon, {
        file: _unref(files),
        "class": "fileIcon"
      }, null, 8, ["file"]), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(props.content.name), 1), _createElementVNode("div", null, _toDisplayString(props.content.size), 1)])], 8, _hoisted_1);
    };
  }
});